import Markdown from 'react-markdown'
import '../App.css'
import logo from '../images/ai.png'




const markdown = `## Meta Title: ##
---------------

Understand How AI Writer Pro Protects Your Information (Privacy Policy)

Focused on user benefit: Learn how AI Writer Pro safeguards your data and ensures privacy while you create content. (Free Trial Available)

**Privacy Policy**
==================

This Privacy Policy ("Policy") describes how AI Writer Pro ("we," "us," or "our") collects, uses, and discloses your information when you use our mobile application ("App").

**Information We Collect**
--------------------------

We collect various types of information for various purposes to improve AI Writer Pro and provide you with the best possible experience.

*   **Information You Provide Directly:**
    
    *   Account Information: When you create an account, you may provide certain personally identifiable information ("PII") such as your name, email address, and password.
        
    *   Content Creation: The text and prompts you enter into the App for content generation (paragraphs, articles, poems, etc.). We do not store the final generated content.
        
*   **Information Collected Automatically:**
    
    *   Usage Data: We collect information about your activity within the App, such as the features you use, the content you generate, and the time of your usage.
        
    *   Device Information: We collect information about the device you use to access the App, such as your device type, operating system, and unique device identifier.
        

**Use of Your Information**
---------------------------

We use the information we collect for various purposes, including:

*   To provide and operate AI Writer Pro
    
*   To improve and personalize your experience
    
*   To develop new features
    
*   To provide customer support
    
*   To send you marketing and promotional communications (with your consent)
    
*   To analyze how AI Writer Pro is used
    

**Free Trial and Paid Subscriptions**
-------------------------------------

AI Writer Pro offers a free trial period. To activate the full features after the trial, you must subscribe to a paid plan. We may use your payment information to process your subscription and may store it for future purchases.

**Sharing of Your Information**
-------------------------------

We may share your information with third-party service providers who help us operate and improve AI Writer Pro. These service providers are contractually obligated to keep your information confidential and secure.

We will not share your PII with any third party for marketing purposes without your consent.

**Data Retention**
------------------

We will retain your information for as long as your account is active or as needed to provide you with the services you request. We may also retain your information for legal or compliance reasons.

**Security**
------------

We take reasonable measures to protect your information from unauthorized access, disclosure, alteration, or destruction. However, no Internet transmission or electronic storage method is 100% secure.

**Your Choices**
----------------

You can access and update your account information at any time. You can also unsubscribe from marketing communications by following the instructions in those communications.

**Children's Privacy**
----------------------

Our App is not directed to children under the age of 13. We do not knowingly collect information from children under 13. If you are a parent or guardian and you believe your child has provided us with information, please contact us.

**Changes to This Policy**
--------------------------

We may update this Policy from time to time. We will notify you of any changes by posting the new Policy on this page.`


export default function PrivacyPolicy(){
    return(
        <div className='whole'>
        <div className='title'>
            <img src={logo} alt='logo' />
            <h1 id="meta-title" ><strong>AI Writer Pro</strong></h1>
        </div>
        <div className='mark'>
            
            <p>Understand How AI Writer Pro Protects Your Information (Privacy Policy)</p>
            <p>Focused on user benefit: Learn how AI Writer Pro safeguards your data and ensures privacy while you create content. (Free Trial Available)</p>
            <h1 id="-privacy-policy-"><strong>Privacy Policy</strong></h1>
            <p>This Privacy Policy (&quot;Policy&quot;) describes how AI Writer Pro (&quot;we,&quot; &quot;us,&quot; or &quot;our&quot;) collects, uses, and discloses your information when you use our mobile application (&quot;App&quot;).</p>
            <h2 id="-information-we-collect-"><strong>Information We Collect</strong></h2>
            <p>We collect various types of information for various purposes to improve AI Writer Pro and provide you with the best possible experience.</p>
            <ul>
            <li><p><strong>Information You Provide Directly:</strong></p>
            <ul>
            <li><p>Account Information: When you create an account, you may provide certain personally identifiable information (&quot;PII&quot;) such as your name, email address, and password.</p>
            </li>
            <li><p>Content Creation: The text and prompts you enter into the App for content generation (paragraphs, articles, poems, etc.). We do not store the final generated content.</p>
            </li>
            </ul>
            </li>
            <li><p><strong>Information Collected Automatically:</strong></p>
            <ul>
            <li><p>Usage Data: We collect information about your activity within the App, such as the features you use, the content you generate, and the time of your usage.</p>
            </li>
            <li><p>Device Information: We collect information about the device you use to access the App, such as your device type, operating system, and unique device identifier.</p>
            </li>
            </ul>
            </li>
            </ul>
            <h2 id="-use-of-your-information-"><strong>Use of Your Information</strong></h2>
            <p>We use the information we collect for various purposes, including:</p>
            <ul>
            <li><p>To provide and operate AI Writer Pro</p>
            </li>
            <li><p>To improve and personalize your experience</p>
            </li>
            <li><p>To develop new features</p>
            </li>
            <li><p>To provide customer support</p>
            </li>
            <li><p>To send you marketing and promotional communications (with your consent)</p>
            </li>
            <li><p>To analyze how AI Writer Pro is used</p>
            </li>
            </ul>
            <h2 id="-free-trial-and-paid-subscriptions-"><strong>Free Trial and Paid Subscriptions</strong></h2>
            <p>AI Writer Pro offers a free trial period. To activate the full features after the trial, you must subscribe to a paid plan. We may use your payment information to process your subscription and may store it for future purchases.</p>
            <h2 id="-sharing-of-your-information-"><strong>Sharing of Your Information</strong></h2>
            <p>We may share your information with third-party service providers who help us operate and improve AI Writer Pro. These service providers are contractually obligated to keep your information confidential and secure.</p>
            <p>We will not share your PII with any third party for marketing purposes without your consent.</p>
            <h2 id="-data-retention-"><strong>Data Retention</strong></h2>
            <p>We will retain your information for as long as your account is active or as needed to provide you with the services you request. We may also retain your information for legal or compliance reasons.</p>
            <h2 id="-security-"><strong>Security</strong></h2>
            <p>We take reasonable measures to protect your information from unauthorized access, disclosure, alteration, or destruction. However, no Internet transmission or electronic storage method is 100% secure.</p>
            <h2 id="-your-choices-"><strong>Your Choices</strong></h2>
            <p>You can access and update your account information at any time. You can also unsubscribe from marketing communications by following the instructions in those communications.</p>
            <h2 id="-children-s-privacy-"><strong>Children&#39;s Privacy</strong></h2>
            <p>Our App is not directed to children under the age of 13. We do not knowingly collect information from children under 13. If you are a parent or guardian and you believe your child has provided us with information, please contact us.</p>
            <h2 id="-changes-to-this-policy-"><strong>Changes to This Policy</strong></h2>
            <p>We may update this Policy from time to time. We will notify you of any changes by posting the new Policy on this page.</p>

        </div>
        <footer className="footer">
                <p>All Rights Reserved Kaizen Global 2024</p>
        </footer>
        </div>
    )
}